import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  AdrDto, YearOfSuitDto
} from "@cradua/data";

@Component({
  selector: 'cradua-adrlist',
  templateUrl: './adrlist.component.html',
  styleUrls: ['./adrlist.component.scss']
})
export class AdrlistComponent implements OnInit {
  @Input() adrProgresss: AdrDto[];
  @Input() yearofsuits: YearOfSuitDto[];
  // @Input() searchSuitProgress: AdrDto[];

  // @Output() emitEvent = new EventEmitter<any>();
  @Output() dispatchView = new EventEmitter<any>();
  isToggle = false;
  listView = false;
  gridView = true;

  constructor() {}

  ngOnInit() {
    if(this.adrProgresss != null && this.adrProgresss.length) {
      this.isToggle = true;
    }
  }


  protected findById = <T>(id: string) =>
    (fieldName: T) => fieldName["id"] === id;

  getYearOfSuit(id) {
    return this.yearofsuits.find(adrp => adrp.id === id);
  }

  onView(value) {
    this.dispatchView.emit(value);
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }
}
